import {
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import Close from "@mui/icons-material/Close";
import Typography from "../../typography/typography";
import TextField from "../../text-field/text-field";
import Button from "../../button/button";
import Modal from "../../modal/modal";
import { useEffect, useMemo, useState } from "react";
import { IPage } from "../../../@types/page";

interface IAddPage {
  open: boolean;
  onClose: () => void;
  page?: IPage;
  handleSubmit: (page: IPage) => void;
  pages?: IPage[];
}

const AddPageModal = ({ open, onClose, page, handleSubmit, pages }: IAddPage) => {
  const [name, setName] = useState<string>();
  const [error, setError] = useState<string>("");
  const pageNames = useMemo(() => pages?.map((page) => page?.name || ""), [pages])

  useEffect(() => {
    setName(page?.name);
  }, [page]);

  useEffect(() => {
    setError("")
  }, []);

  const handleSave = () => {
    let newPage: any = {};
    if (page) {
      newPage = {
        ...page,
      };
    }
    newPage["name"] = name;

    handleSubmit(newPage);
    setName("");
    onClose();
  };

  const handleInputChange = (e: any) => {
    const value = e.target.value

    setName(value)
    if (pageNames?.includes(value.trim())) {
      setError("Page name already in use")
    } else if (!value.trim()) {
      setError("Page name can not be empty")
    } else {
      setError("")
    }
  }

  return (
    <>
      <Modal fullWidth onClose={onClose} open={open}>
        <DialogTitle>
          <Typography type="s3" weight="medium" color={"theme.secondary.1000"}>
            {page ? "Edit" : "Add"} New View
          </Typography>
          <IconButton edge="end" onClick={onClose} size="small">
            <Close fontSize="inherit" />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <TextField
            label="View Name"
            fullWidth
            placeholder="Enter view name"
            error={error}
            helperText={error}
            value={name}
            onChange={handleInputChange}
          />
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            onClick={()=>{
              onClose();
              setName("");
            }}
            style={{
              color: "black",
            }}
          >
            Cancel
          </Button>
          <Button disabled={error || !name} onClick={handleSave}>Save</Button>
        </DialogActions>
      </Modal>
    </>
  );
};

export { AddPageModal };
export default AddPageModal;
